var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "업로드",
        "cancel-title": "취소",
        size: "lg",
        title: "리소스 업로드",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showWebResourceFileUpload,
        callback: function ($$v) {
          _vm.showWebResourceFileUpload = $$v
        },
        expression: "showWebResourceFileUpload",
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "리소스 파일",
                    "label-for": "web-resource-files",
                  },
                },
                [
                  _c("b-form-file", {
                    ref: "fileInput",
                    attrs: {
                      multiple: "",
                      placeholder: _vm.placeholderText,
                      state: !_vm.isFileBlocked,
                      "file-name-formatter": _vm.formatNames,
                      accept: _vm.acceptFileExt,
                    },
                    on: { input: _vm.inputFiles },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "12" } },
            _vm._l(_vm.webResourceDataList, function (item, idx) {
              return _c(
                "div",
                { key: idx },
                [
                  _c(
                    "b-input-group",
                    [
                      _c(
                        "b-input-group-prepend",
                        [
                          _c(
                            "b-input-group-text",
                            { staticStyle: { width: "20rem" } },
                            [
                              _vm._v(
                                " " + _vm._s(item.WebResourceFileName) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "이용 목적을 입력해주세요 (최대 250자)",
                          maxlength: "250",
                        },
                        model: {
                          value: item.Title,
                          callback: function ($$v) {
                            _vm.$set(item, "Title", $$v)
                          },
                          expression: "item.Title",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-input-group-text",
                            { staticStyle: { width: "6rem" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      item.WebResourceFileSize /
                                      (1024 * 1024)
                                    ).toFixed(2)
                                  ) +
                                  " MB "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }